import { AttendanceSingleEmployeeType, mapAttendanceSingleEmployeeTypes } from "./AttendanceSingleEmployeeType";
import { AttendanceTableDataType, mapAttendanceTableDataTypes } from "./AttendanceTableDataType";

export interface EmployeeAttendanceType {
    full_list?: AttendanceSingleEmployeeType[];
    table_data?: AttendanceTableDataType[];

}


// to single object maping
export const mapEmployeeAttendanceType = (data:any): EmployeeAttendanceType => {
    if(!data){
        throw new Error('Invalid Data')
    }
    const  res: EmployeeAttendanceType ={
        full_list:mapAttendanceSingleEmployeeTypes(data.full_list),
        table_data:mapAttendanceTableDataTypes(data.table_data),
    }
    return res;
}

// maping list objects
export const mapEmployeeAttendanceTypes = (data:any[]): EmployeeAttendanceType[] => {
     if (!Array.isArray(data)) {
       throw new Error('Invalid Data');
     }
     return data.map(mapEmployeeAttendanceType);
}